import {FullGameFetchHandler} from "../../../core/handlers/full-game.fetch-handler";
import {ACTION_TYPES, COMPONENT_STATES, HISTORY_ACTIONS} from "../../../core/consts";
import {GameCenterWidgetController} from "../game-center-widget.controller";
import {GameCenterWidgetState} from "../models/game-center-widget.state";

export class GameCenterWidgetFetchHandler extends FullGameFetchHandler {
  state: GameCenterWidgetState;
  controller: GameCenterWidgetController;

  async onLoaded(controller: GameCenterWidgetController) {
    const isBack: Boolean = this.historyManager?.location?.action === HISTORY_ACTIONS.pop && !!this.state.dataSource;

    if (!isBack) {
      this.controller.store.setComponentState(COMPONENT_STATES.loading);
    }

    await this.action();
  }

  async action() {
    const dataSource = await this.fetch();

    await this.controller.action(ACTION_TYPES.populateData, {dataSource});

    return dataSource;
  }

  onDidUpdate(prevProps, nextProps) {
    const matchupIdChange: Boolean = prevProps.matchupId !== nextProps.matchupId;
    const gameIdChanged: Boolean = prevProps.gameId !== nextProps.gameId;

    if (gameIdChanged || matchupIdChange) {
      const index: Number = this.appStore.state.context.tabIndex;
      this.controller.action(ACTION_TYPES.populateData, nextProps.location?.state);
      this.controller.action(ACTION_TYPES.tabChange, {index})

      this.action();
    }
  }
}
